function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden],[tabindex^='-']):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video:not([data-keep-playing])').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not([type=reset]):not([type=submit]):not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    }
  }

  openMenuDrawer(summaryElement) {
    if (this.classList.contains('shirt-quiz__drawer')) {
      Shopify.analytics.publish('shirt_quiz_begin');
    }
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    const autofocusElement = summaryElement.nextElementSibling.querySelector('[autofocus]');
    trapFocus(this.mainDetailsToggle, autofocusElement || summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    const productInfo = this.closest('product-info');
    if (productInfo) productInfo.classList.add('drawer-opened');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    if (!this.mainDetailsToggle.parentElement.closest('details') || this.closest('.product__accordion')) {
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    const inlineNavLinks = this.querySelectorAll('.header__inline-menu a');
    inlineNavLinks.forEach(link => link.addEventListener('click', this.onInlineLinkClick.bind(this)));
  }

  onInlineLinkClick(event) {
    const handle = event.currentTarget.dataset.linkHandle;
    const associatedSummary = this.querySelector(`[id^="Details-menu-drawer-menu-item-"] summary[data-link-handle="${handle}"]`);
    if (!associatedSummary) return;

    event.preventDefault();
    this.mainDetailsToggle.querySelector('summary').click();
    setTimeout(() => associatedSummary.click());
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const iframe = this.querySelector('iframe');
    if (iframe) {
      window.addEventListener('message', (event) => {
        if (event.data === 'close' && iframe.src.includes(event.origin)) this.hide();
      }, false);
    }
    if (this.querySelector('[id^="ModalClose-"]')) this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();

    // Lazy load iframe
    const lazyIframe = this.querySelector('iframe[data-src]:not([src])');
    if (lazyIframe) lazyIframe.src = lazyIframe.dataset.src;

    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      const elementToClone = this.querySelector('template').content.firstElementChild;
      if (!elementToClone) return;
      content.appendChild(elementToClone.cloneNode(true));

      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.hasAttribute('data-desktop-sources') || deferredElement.hasAttribute('data-mobile-sources')) {
        if (deferredElement.hasAttribute('data-mobile-sources') && window.matchMedia('(max-width: 749px)').matches) {
          this.setAttribute('loaded', true);
          const mobileSources = JSON.parse(deferredElement.dataset.mobileSources);
          mobileSources.forEach((source) => {
            const sourceElem = document.createElement('source');
            sourceElem.src = source.src;
            sourceElem.type = source.type;
            deferredElement.append(sourceElem);
          });
        } else if (deferredElement.hasAttribute('data-desktop-sources')) {
          this.setAttribute('loaded', true);
          const desktopSources = JSON.parse(deferredElement.dataset.desktopSources);
          desktopSources.forEach((source) => {
            const sourceElem = document.createElement('source');
            sourceElem.src = source.src;
            sourceElem.type = source.type;
            deferredElement.append(sourceElem);
          });
        }
      }
      if (deferredElement.hasAttribute('muted')) deferredElement.muted = true;
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.hasAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VideoAutoplay extends DeferredMedia {
  constructor() {
    super();
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
    if (isReduced) return;

    new IntersectionObserver(this.onIntersect, {
      threshold: 0.1,
    }).observe(this);
  }
  onIntersect(elements) {
    elements.forEach((element) => (element.isIntersecting) ? element.target.play() : element.target.pause())
  }
  play() {
    if (typeof this.deferredElement === 'undefined') {
      super.loadContent();
      this.deferredElement = this.querySelector('video');
      return;
    } else if (!this.deferredElement) {
      console.warn('No <video> found in <video-autoplay> tag : ', this);
      return;
    }
    this.deferredElement.play();
  }
  pause() {
    if (!this.deferredElement) return;
    this.deferredElement.pause();
  }
}
customElements.define('video-autoplay', VideoAutoplay);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    if (event.target.closest('.size-guide-drawer')) return;
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.toggleStickyAddButton(true, '', false);
    this.toggleBroderieAddButton(true, '', false);
    this.toggleEResaButton(true);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.toggleStickyAddButton(true, '', true);
      this.toggleBroderieAddButton(true, '', true);
      this.toggleEResaButton(true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, [id^="product-form-broderie-"]`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]') || productForm.querySelector('input[name="items[0][id]"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const compareAtPriceSource = html.getElementById(`compareAtPrice-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const compareAtPriceDestination = document.getElementById(`compareAtPrice-${this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const eResaModalSource = html.getElementById(`eResaModal-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const eResaModalDestination = document.getElementById(`eResaModal-${this.dataset.section}`);
        // const eResaOpenerSource = html.querySelector(`[data-modal="#eResaModal-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}"] .button`);
        const broderieOpenerSource = html.getElementById(`BroderieOpener-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const broderieOpenerDestination = document.getElementById(`BroderieOpener-${this.dataset.section}`);
        const stockInfoSource = html.getElementById(`VariantStockInfo-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const stockInfoDestination = document.getElementById(`VariantStockInfo-${this.dataset.section}`);

        if (stockInfoSource && stockInfoDestination) stockInfoDestination.innerHTML = stockInfoSource.innerHTML;
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (compareAtPriceSource && compareAtPriceDestination) compareAtPriceDestination.innerHTML = compareAtPriceSource.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (eResaModalSource && eResaModalDestination) eResaModalDestination.innerHTML = eResaModalSource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }
        if (broderieOpenerSource && broderieOpenerDestination) broderieOpenerDestination.innerHTML = broderieOpenerSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
        this.toggleStickyAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
        this.toggleBroderieAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
        this.toggleEResaButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true);

        const eResaButton = document.querySelector('[data-modal^="#eResaModal-"] .button');
        // if (eResaButton && eResaOpenerSource) {
        //   eResaButton.classList.toggle('hidden', eResaOpenerSource.classList.contains('hidden'));
        // }
        if (eResaButton && this.currentVariant.available) {
          eResaButton.classList.remove('hidden');
        } else if (eResaButton) {
          eResaButton.classList.add('hidden');
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        });
      });
  }

  toggleEResaButton(disable = true) {
    const eResaButton = document.querySelector('[data-modal^="#eResaModal-"] .button');
    if (!eResaButton) return;

    if (disable) {
      eResaButton.setAttribute('disabled', 'disabled');
    } else {
      eResaButton.removeAttribute('disabled');
    }
  }

  toggleStickyAddButton(disable = true, text, modifyClass = true) {
    const productFormSticky = document.getElementById(`product-form-${this.dataset.section}-sticky`);
    if (!productFormSticky) return;
    const addButton = productFormSticky.querySelector('[name="add"]');
    const addButtonText = productFormSticky.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  toggleBroderieAddButton(disable = true, text, modifyClass = true) {
    const productFormBroderie = document.querySelector('[id^="product-form-broderie-"]');
    if (!productFormBroderie) return;
    const broderieTextInput = document.querySelector('input[name="items[0][properties][_TEXT]"]');
    if (!broderieTextInput) return;
    const addButton = productFormBroderie.querySelector('[name="add"]');
    const addButtonText = productFormBroderie.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      productFormBroderie.setAttribute('data-disabled', true);
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButtonText.textContent = window.variantStrings.addToCart;
      productFormBroderie.removeAttribute('data-disabled');

      if (!broderieTextInput.value) {
        addButton.setAttribute('disabled', 'disabled');
      } else {
        addButton.removeAttribute('disabled');
      }
    }

    if (!modifyClass) return;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class LibraryLoader {
  static STATUS_REQUESTED = "requested";
  static STATUS_LOADED = "loaded";
  static libraries = {
    splide: {
      tagId: "splide",
      src: window.libs.splide,
      type: "script"
    }
  };

  static load(libraryName) {
    const library = this.libraries[libraryName];
    if (!library) {
      return;
    }
    if (library.status === this.STATUS_REQUESTED) {
      return library.promise;
    }
    if (library.status === this.STATUS_LOADED) {
      return Promise.resolve();
    }
    const promise = new Promise((resolve, reject) => {
      const tag = library.type === "script" ? document.createElement("script") : document.createElement("link");
      tag.id = library.tagId;
      tag.onerror = reject;
      tag.onload = () => {
        library.status = this.STATUS_LOADED;
        resolve();
      };
      if (library.type === "script") {
        tag.src = library.src;
      } else {
        tag.href = library.src;
        tag.rel = "stylesheet";
        tag.type = "text/css";
      }
      document.body.appendChild(tag);
    });
    library.promise = promise;
    library.status = this.STATUS_REQUESTED;
    return promise;
  }
}

class SplideCarousel extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    if (this.slideNodes.length < 2) {
      this.classList.add("is-initialized", "is-active");
      return;
    }
    if (this.splideInstance) {
      if (this.slideNodes.length < 2) this.splideInstance.options.set("drag", false);
      this.splideInstance.refresh();
      return;
    }

    this._createSplide();
  }

  async disconnectedCallback() {
    if (this.splideInstance) {
      this.splideInstance.destroy();
    }
  }

  get slideNodes() {
    return this.querySelectorAll(".splide__slide");
  }

  get splideConfig() {
    return JSON.parse(this.getAttribute("splide-config"));
  }

  get splideInstance() {
    return this.splide;
  }

  _lazyLoad() {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        this.splideInstance.Components.Slides.forEach((Slide) => {
          Slide.slide.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.setAttribute('loading', 'eager');
          });
        });
        observer.unobserve(this);
      }
    });
    observer.observe(this);
  }

  async _createSplide() {
    await LibraryLoader.load("splide");
    this.splide = new Splide(this, { ...this.splideConfig, drag: this.slideNodes.length > 1 }).mount();
    this._lazyLoad();

    // Trigger splide:mounted event
    this.dispatchEvent(new CustomEvent("splide:mounted", { bubbles: true }));
  }
}
customElements.define("splide-carousel", SplideCarousel);

if (window) {
  const urlParams = new URLSearchParams(window?.location?.search);
  const sales_token = urlParams.get('ts');
  if (sales_token) {
    window.localStorage.setItem('kolsquare', JSON.stringify({ sales_token }));
  }
}

// Refresh cart drawer on back/forward navigation
window.addEventListener('DOMContentLoaded', (event) => {
  const isCached = performance.getEntriesByType("navigation")[0].transferSize === 0;

  if (isCached) {
    const cartDrawer = document.querySelector('cart-drawer');
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Cache-control'] = 'no-cache';
    config.method = 'GET';
    delete config.headers['Content-Type'];

    const sectionsId = cartDrawer.getSectionsToRender().map((section) => section.id);
    fetch(`${window.Shopify.routes.root}?sections=${sectionsId.join(',')}&sections_url=${window.location.pathname}`, config)
      .then((response) => response.json())
      .then((response) => {
        cartDrawer.getSectionsToRender().forEach((section => {
          const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          sectionElement.innerHTML =
            cartDrawer.getSectionInnerHTML(response[section.id], section.selector);
        }));
        console.log('CartDrawer re-rendered', response);
      });
  }
});

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 0;
    this.changeSlideSpeed = this.getAttribute('change-slide-speed') || 5000;
    this.slides = this.querySelectorAll('[data-announcement-bar-slide]');
    this.autoRotate = this.slides.length > 1;
    this.autoRotateInterval = null;
  }

  connectedCallback() {
    this.autoRotate && this.startAutoRotate();
    this.addEventListener('mouseenter', this.stopAutoRotate.bind(this));
    this.addEventListener('mouseleave', this.startAutoRotate.bind(this));
  }

  disconnectedCallback() {
    this.autoRotate && this.stopAutoRotate();
    this.removeEventListener('mouseenter', this.stopAutoRotate.bind(this));
    this.removeEventListener('mouseleave', this.startAutoRotate.bind(this));
  }

  startAutoRotate() {
    this.autoRotateInterval = setInterval(this.nextSlide.bind(this), this.changeSlideSpeed);
  }

  stopAutoRotate() {
    clearInterval(this.autoRotateInterval);
  }

  previousSlide() {
    this.slides[this.currentSlide].classList.remove('--active');
    this.currentSlide = this.currentSlide === 0 ? this.slides.length - 1 : this.currentSlide - 1;
    this.slides[this.currentSlide].classList.add('--active');
  }

  nextSlide() {
    this.slides[this.currentSlide].classList.remove('--active');
    this.currentSlide = this.currentSlide === this.slides.length - 1 ? 0 : this.currentSlide + 1;
    this.slides[this.currentSlide].classList.add('--active');
  }
}
customElements.define('announcement-bar', AnnouncementBar);

class ReetagsWrapper extends HTMLElement {
  static scriptLoaded = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this.loadReetagsScript();
  }

  loadReetagsScript() {
    if (ReetagsWrapper.scriptLoaded) return;

    const script = document.createElement('script');
    script.src = 'https://player.reetags.com/iframe/js/script_iframe.js';
    script.defer = true;
    script.onload = () => {
      ReetagsWrapper.scriptLoaded = true;
    };

    document.body.appendChild(script);
  }
}
customElements.define('reetags-wrapper', ReetagsWrapper);